'use client';
import React from 'react';

import { SessionContext } from '@benzinga/session-context';
import { LayoutList, LayoutManager, LayoutManagerEvent } from '@benzinga/layout-manager';
import Hooks from '@benzinga/hooks';

/**
 * Hook to get layouts
 */
export const useLayouts = (): LayoutList | undefined => {
  const session = React.useContext(SessionContext);
  const layoutManager = session.getManager(LayoutManager);
  const layouts = layoutManager.getStoredLayoutsList();
  const update = Hooks.useForceUpdate();

  Hooks.useSubscriber(layoutManager, (event: LayoutManagerEvent) => {
    switch (event.type) {
      case 'layouts:layouts_list_item_update':
      case 'layouts:layouts_list_update':
        update();
        break;
    }
  });

  return layouts;
};
